/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsinvitesaccepted2Inputs */

const en_statsinvitesaccepted2 = /** @type {(inputs: Statsinvitesaccepted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepted`)
};

const de_statsinvitesaccepted2 = /** @type {(inputs: Statsinvitesaccepted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angenommen`)
};

/**
* | output |
* | --- |
* | "Accepted" |
*
* @param {Statsinvitesaccepted2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsinvitesaccepted2 = /** @type {((inputs?: Statsinvitesaccepted2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsinvitesaccepted2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsinvitesaccepted2(inputs)
	return de_statsinvitesaccepted2(inputs)
});
export { statsinvitesaccepted2 as "statsInvitesAccepted" }